"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/typeof"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Icon = _interopRequireDefault(require("@mui/material/Icon"));
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _helpers = require("../utils/helpers");
var hiSvgIcons = _interopRequireWildcard(require("../hi-svg-icons"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var useStyles = exports.useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: function color(props) {
        if (theme.palette[props.color]) {
          return theme.palette[props.color].main;
        }
        return theme.palette.primary.main;
      }
    },
    faIcon: {
      fontSize: 20
    }
  };
});
var HiIcon = _react.default.forwardRef(function (props, ref) {
  var children = props.children,
    className = props.className,
    icon = props.icon,
    size = props.size,
    color = props.color,
    other = (0, _objectWithoutProperties2.default)(props, ["children", "className", "icon", "size", "color"]);
  var classes = useStyles(props);
  var iconName = icon !== null ? icon : children;
  if (iconName && (0, _typeof2.default)(iconName) === 'object') {
    return iconName;
  }
  var iconType = (0, _react.useMemo)(function () {
    if (iconName && iconName.indexOf('fa-') === 0) {
      return 'line_awesome';
    } else if (iconName && iconName.indexOf('hi_') === 0) {
      return 'hipay';
    } else {
      return 'mui';
    }
  }, [iconName]);
  switch (iconType) {
    case 'line_awesome':
      return /*#__PURE__*/_react.default.createElement("i", (0, _extends2.default)({
        ref: ref,
        className: (0, _classnames.default)('fa', iconName, className, (0, _defineProperty2.default)({}, classes.root, color !== 'inherit')),
        style: {
          fontSize: size
        }
      }, other));
    case 'hipay':
      var HipayIconName = hiSvgIcons[(0, _helpers.capitalize)((0, _helpers.camelize)(iconName))];
      return /*#__PURE__*/_react.default.createElement(HipayIconName, (0, _extends2.default)({
        ref: ref,
        className: (0, _classnames.default)(className, (0, _defineProperty2.default)({}, classes.root, color !== 'inherit')),
        color: 'currentColor',
        size: size
      }, other));
    case 'mui':
    default:
      // console.log({ ...props });
      return /*#__PURE__*/_react.default.createElement(_Icon.default, (0, _extends2.default)({
        ref: ref,
        className: (0, _classnames.default)(className, (0, _defineProperty2.default)({}, classes.root, color !== 'inherit')),
        color: 'inherit',
        style: {
          fontSize: size
        }
      }, other), iconName);
  }
});
HiIcon.defaultProps = {
  color: 'inherit',
  icon: null,
  size: 20
};
var _default = exports.default = HiIcon;